// ============================================
// FOOTER COMPONENT - Shrileela Beach Resort
// ============================================

export const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 75, behavior: 'smooth' });
  };
  const year = new Date().getFullYear();

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Jost:wght@300;400;500;600&display=swap');
        .footer-root {
          background: #111d11;
          color: rgba(255,255,255,0.65);
          font-family: 'Jost', sans-serif;
          padding: 64px 24px 32px;
        }
        .footer-inner { max-width: 1200px; margin: 0 auto; }
        .footer-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.5fr;
          gap: 48px;
          margin-bottom: 48px;
        }
        .footer-brand-name {
          font-family: 'Playfair Display', serif;
          font-size: 28px; color: #fff; margin: 0 0 4px;
        }
        .footer-brand-sub { font-size: 11px; letter-spacing: 2.5px; text-transform: uppercase; color: #a8d5a2; margin-bottom: 16px; }
        .footer-brand-desc { font-size: 14px; line-height: 1.8; margin-bottom: 24px; font-weight: 300; }
        .footer-socials { display: flex; gap: 10px; }
        .footer-social-btn {
          width: 38px; height: 38px; border-radius: 10px;
          background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.1);
          display: flex; align-items: center; justify-content: center;
          font-size: 16px; cursor: pointer; transition: all 0.25s; text-decoration: none;
        }
        .footer-social-btn:hover { background: #3d5a3e; border-color: #3d5a3e; transform: translateY(-2px); }

        .footer-col-title { font-size: 13px; font-weight: 700; color: #fff; letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 20px; }
        .footer-links { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }
        .footer-link-btn {
          background: none; border: none; color: rgba(255,255,255,0.6); font-family: 'Jost', sans-serif;
          font-size: 14px; cursor: pointer; text-align: left; padding: 0; transition: color 0.2s; font-weight: 300;
        }
        .footer-link-btn:hover { color: #a8d5a2; }

        .footer-contact-item { display: flex; gap: 10px; margin-bottom: 14px; font-size: 14px; line-height: 1.5; font-weight: 300; }
        .footer-contact-item a { color: rgba(255,255,255,0.7); text-decoration: none; transition: color 0.2s; }
        .footer-contact-item a:hover { color: #a8d5a2; }

        .footer-divider { border: none; border-top: 1px solid rgba(255,255,255,0.08); margin: 0 0 24px; }
        .footer-bottom { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; font-size: 13px; }
        .footer-bottom-links { display: flex; gap: 24px; }
        .footer-bottom-link { color: rgba(255,255,255,0.45); text-decoration: none; transition: color 0.2s; }
        .footer-bottom-link:hover { color: #a8d5a2; }

        @media (max-width: 900px) { .footer-grid { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 600px) { .footer-grid { grid-template-columns: 1fr; } .footer-bottom { flex-direction: column; text-align: center; } }
      `}</style>

      <footer className="footer-root">
        <div className="footer-inner">
          <div className="footer-grid">
            <div>
              <div style={{ fontSize: '32px', marginBottom: '8px' }}>🌴</div>
              <h3 className="footer-brand-name">Shrileela</h3>
              <div className="footer-brand-sub">Beach Resort</div>
              <p className="footer-brand-desc">
                An affordable coastal retreat at Murud Beach, offering comfort, warmth, and the soothing sound of the Arabian Sea — managed by Chaitul Hospitality LLP.
              </p>
              <div className="footer-socials">
                <a href="#" className="footer-social-btn" aria-label="Facebook">📘</a>
                <a href="#" className="footer-social-btn" aria-label="Instagram">📸</a>
                <a href={`https://wa.me/919404617122`} className="footer-social-btn" aria-label="WhatsApp" target="_blank" rel="noreferrer">💬</a>
              </div>
            </div>

            <div>
              <div className="footer-col-title">Quick Links</div>
              <ul className="footer-links">
                {['home','rooms','dining','gallery','events','contact'].map(id => (
                  <li key={id}>
                    <button className="footer-link-btn" onClick={() => scrollTo(id)}>
                      {id.charAt(0).toUpperCase() + id.slice(1)}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="footer-col-title">Services</div>
              <ul className="footer-links">
                {['Beach Access','Room Service','Seafood Dining','Event Hosting','Free WiFi','Parking'].map(s => (
                  <li key={s}><span className="footer-link-btn" style={{ cursor: 'default' }}>{s}</span></li>
                ))}
              </ul>
            </div>

            <div>
              <div className="footer-col-title">Contact</div>
              <div className="footer-contact-item">
                <span>📍</span>
                <span>Near Durga Devi Temple, Murud Beach, Tal. Dapoli, Dist. Ratnagiri – 415713</span>
              </div>
              <div className="footer-contact-item">
                <span>📞</span>
                <div>
                  <a href="tel:+919404617122">+91 9404617122</a><br />
                  <a href="tel:+919404992515">+91 9404992515</a>
                </div>
              </div>
              <div className="footer-contact-item">
                <span>✉️</span>
                <a href="mailto:chaitulhospitalityllp@gmail.com">chaitulhospitalityllp@gmail.com</a>
              </div>
            </div>
          </div>

          <hr className="footer-divider" />
          <div className="footer-bottom">
            <span>© {year} Shrileela Beach Resort · Chaitul Hospitality LLP. All rights reserved.</span>
            <div className="footer-bottom-links">
              <a href="#" className="footer-bottom-link">Privacy Policy</a>
              <a href="#" className="footer-bottom-link">Terms of Service</a>
              <a href="#" className="footer-bottom-link">Cancellation Policy</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

// ============================================
// FLOATING BOOK BUTTON - Shrileela Beach Resort
// ============================================

import { useState, useEffect } from 'react';

export const FloatingBookButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToBooking = () => {
    const el = document.getElementById('booking');
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 75, behavior: 'smooth' });
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Jost:wght@600&display=swap');
        .float-btn-wrap {
          position: fixed; bottom: 28px; right: 28px; z-index: 999;
          display: flex; flex-direction: column; gap: 12px; align-items: flex-end;
          transition: opacity 0.3s, transform 0.3s;
        }
        .float-btn-wrap.hidden { opacity: 0; pointer-events: none; transform: translateY(20px); }
        .float-book-btn {
          background: #3d5a3e; color: #fff; border: none;
          padding: 14px 24px; border-radius: 50px;
          font-family: 'Jost', sans-serif; font-size: 14px; font-weight: 600;
          cursor: pointer; box-shadow: 0 8px 30px rgba(61,90,62,0.45);
          transition: all 0.25s; display: flex; align-items: center; gap: 8px;
        }
        .float-book-btn:hover { background: #2d4230; transform: translateY(-2px); box-shadow: 0 12px 40px rgba(61,90,62,0.5); }
        .float-wa-btn {
          width: 52px; height: 52px; border-radius: 50%;
          background: #25d366; color: #fff; border: none;
          font-size: 24px; cursor: pointer;
          box-shadow: 0 8px 24px rgba(37,211,102,0.45);
          transition: all 0.25s; display: flex; align-items: center; justify-content: center;
        }
        .float-wa-btn:hover { transform: scale(1.08) translateY(-2px); box-shadow: 0 12px 30px rgba(37,211,102,0.5); }
      `}</style>
      <div className={`float-btn-wrap ${visible ? '' : 'hidden'}`}>
        <button className="float-book-btn" onClick={scrollToBooking}>🏖️ Book Now</button>
        <button className="float-wa-btn"
          onClick={() => window.open(`https://wa.me/919404617122?text=${encodeURIComponent('Hi! I want to book a room at Shrileela Beach Resort.')}`, '_blank')}
          title="WhatsApp">
          💬
        </button>
      </div>
    </>
  );
};

export default Footer;